module.exports = __webpack_public_path__ + "img/图片8.aaa1dfd2.png";